import { Exclude, Expose, Type } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class SnIntegrationAuthToken extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public key: string;

  @Expose({ name: 'updatedTimestamp' })
  @Type(() => Date)
  @Exclude({ toPlainOnly: true })
  public updatedAt: Date;

  @Expose({ name: 'createdTimestamp' })
  @Type(() => Date)
  @Exclude({ toPlainOnly: true })
  public createdAt: Date;

  @Expose()
  public name: string;

  @Expose()
  public isActive: boolean;

  @Expose({ name: 'expirationTimeStamp' })
  @Type(() => Date)
  @Exclude({ toPlainOnly: true })
  public expiredAt: Date;

  @Expose()
  public organization: string;

  @Expose()
  public integrationType: string;

  constructor(data?: any) {
    super();
    this.fromJSON(data);
  }
}
